import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">精彩视频</h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">热门吃瓜视频精选，点击即可观看完整内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.slice(0, 5).map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                    <i className="ri-play-fill text-2xl text-background-50 ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-background-100 font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full">{item.tag}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views} 次观看
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}